<template>
  <base-section id="mobile">
    <base-section-heading title="Our Products">
      Check out some of the awesome things we make at 4D Labs!
    </base-section-heading>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <base-section-heading
            align="left"
            subtitle="Interact, Record, Share"
            tag="h2"
            title="Engage XR"
          >
            Engage is a mobile app providing users with a database of their favorite artists to interact with, record video or photo and share with their friends. Users can see their artists anywhere at any angle using the innovation of Augmented Reality, immersing themselves in the scene while capturing to share on any platform. Engage with your favorite artist today, available on App Store and Google Play.
          </base-section-heading>

          <v-row>
            <v-col
              v-for="([icon, title], i) in features"
              :key="i"
              cols="12"
              md="6"
            >
              <div class="d-flex align-center">
                <base-avatar
                  :icon="icon"
                  class="mr-6"
                  color="primary"
                  dark
                  outlined
                />

                <v-responsive max-width="112">
                  <base-subtitle
                    :title="title"
                    class="text--primary"
                  />
                </v-responsive>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-img
            :src="require('@/assets/mobile.png')"
            class="ma-auto"
            contain
            height="400"
            max-width="300"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMobile',

    data: () => ({
      features: [
        ['mdi-account-music-outline', 'Choose your Artist'],
        ['mdi-camera-wireless', 'Capture Anywhere'],
        ['mdi-share-variant', 'Share Anywhere'],
        ['mdi-augmented-reality', 'Augmented Reality'],
      ],
    }),
  }
</script>
